import { call, put, takeLatest } from 'redux-saga/effects';

import * as musicActions from './musicActions.js';
import { updateMusicApiCall } from './musicAPI.js';

function* updateMusicSaga({ payload }) {
  try {
    const { data } = yield call(updateMusicApiCall, payload);
    yield put(musicActions.musicUpdateStore(data));
  } catch (error) {
    yield put(musicActions.musicUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* musicWatcher() {
  yield takeLatest(musicActions.musicUpdateRequest.type, updateMusicSaga);
}
